///<reference path="../../../../components/goals/goalBase.controller.ts" />
///<reference path="../../../../plugins/dashboardGoals/dashboardGoalsGraphs.logic.ts" />
///<reference path="../../../../plugins/dashboardGoals/dashboardGoals.controller.ts" />

module Meevo.Plugins.Controls {

    import GoalCategoryEnum = Meevo.Components.Goals.GoalCategoryEnum;
    import GoalInputTypeEnum = Meevo.Components.Goals.GoalInputTypeEnum;
    import IGoalColumn = Meevo.Components.Goals.IGoalColumn;
    import ISelectItem = Meevo.Model.ISelectItem;
    import GoalDateRangeEnum = Meevo.Components.Goals.GoalDateRangeEnum;
    import IDashboardGoalModel = Meevo.Plugins.DashboardGoals.IDashboardGoalModel;
    import IDateRanges = Meevo.Plugins.DashboardGoals.DATE_RANGES;

    import IBarChartItem = Meevo.Plugins.DashboardGoals.IBarChartItem;
    import IDashboardGoalColumn = Meevo.Plugins.DashboardGoals.IDashboardGoalColumn;
    import IDashboardGoalLogic = Meevo.Plugins.DashboardGoals.IDashboardGoalsGraphsLogic;
    


    const GOAL_CATEGORY_LABELS = Meevo.Plugins.DashboardGoals.GOAL_CATEGORY_LABELS;
    const GoalDateRanges = Meevo.Plugins.DashboardGoals.GOAL_DATE_RANGES;
    import GoalCategoriesDateRanges = Meevo.Plugins.DashboardGoals.GOAL_CATEGORIES_DATERANGES;
    

    declare let d3: any;
    interface DateRangeListItem {
        value: GoalDateRangeEnum;
        label: string;
    }
    interface IMonthlyBarChartItem {
        label: string;
        goal: number;
        actual: number;
        year: number;
    }
    interface DateRangeList extends Array<DateRangeListItem> { }
    const INPUT_TYPE_KEY = Meevo.Plugins.DashboardGoals.INPUT_TYPE_KEY;
    const LABEL_MONTH = Meevo.Plugins.DashboardGoals.LABEL_MONTH;

    class MeevoGoalsTileComponent implements angular.IComponentController {


        static $inject = [
            '$scope',
            '$translate',
            'meevo.plugins.docsAndForms.DashboardGoalsGraphsLogic',
            '$locale',
            'meevo.AppSettings',
            'meevo.components.busy.BusyService',
            'meevo.components.common.DataService',
        ];


        public measurement: GoalInputTypeEnum;
        public goal: number;
        public actual: number;
        public percentUpDown: number;
        public differenceText: string;
        public chartClass: string;
        public goalText: string;
        public actualText: string;
        public numberDisplayType: number;
        public title: string;
        public dateRange: DateRangeList = [];
        public salesData: any[];
        public onDateRangeSelection?: (...args: any[]) => void;

        public selectedDateRangeList: DateRangeList = [];
        public selectedDateRange: DateRangeListItem;
        public currentGoalsModel: IDashboardGoalModel;
        public dateRangeText: string;
        public goalsCategory: GoalCategoryEnum;
        public stars: any[] = [];
        public globalSelectedDateRange: GoalDateRangeEnum;

        public averageTicketDateRangeList: DateRangeList = [];
        public salesDateRangeList: DateRangeList = [];
        public rebookDateRangeList: DateRangeList = [];
        public ratingsDateRangeList: DateRangeList = [];
        public productivityDateRangeList: DateRangeList = [];
        public retentionDateRangeList: DateRangeList = [];
        public ratesDateRangeList: DateRangeList = [];
        public frequencyOfVisitDateRange: DateRangeList = [];

        public averageTicketDateRange: GoalDateRangeEnum = GoalDateRangeEnum.Today;
        public salesDateRange: GoalDateRangeEnum = GoalDateRangeEnum.Today;
        public rebookDateRange: GoalDateRangeEnum = GoalDateRangeEnum.ThisMonth;
        public newClientDateRange: GoalDateRangeEnum = GoalDateRangeEnum.LastTwelveMonths;
        public ratingsDateRange: GoalDateRangeEnum = GoalDateRangeEnum.LastTwelveMonths;
        public requestRateDateRange: GoalDateRangeEnum = GoalDateRangeEnum.SpecificYear;
        public retentionDateRange: GoalDateRangeEnum = GoalDateRangeEnum.SpecificYear;
        public productivityDateRange: GoalDateRangeEnum = GoalDateRangeEnum.Today;

        public productivityGoalsData: IMonthlyBarChartItem[];
        public measurementSelect: ISelectItem<GoalInputTypeEnum>[];
        public currencySymbol = this.$locale.NUMBER_FORMATS.CURRENCY_SYM;
        public smallerFont: boolean;
        public goalCategoryEnum = GoalCategoryEnum;
        public globalSelectedYear: number;

        constructor(private $scope: ng.IScope,
            private $translate: ng.translate.ITranslateService,
            private dashboardGoalsLogic: IDashboardGoalLogic,
            private $locale: angular.ILocaleService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected dataService: Meevo.Components.BaseClasses.IDataService
        ) {

            if (this.goalsCategory == GoalCategoryEnum.Service || this.goalsCategory == GoalCategoryEnum.Retail) {
                if(!_.isUndefined(this.selectedDateRange))
                    this.selectedDateRange.value = GoalDateRangeEnum.Today;
            }
            
            Object.keys(GOAL_CATEGORY_LABELS).forEach((key) => {
                GOAL_CATEGORY_LABELS[key] = $translate.instant(GOAL_CATEGORY_LABELS[key]);
            });

            this.measurementSelect = [
                {
                    value: GoalInputTypeEnum.Currency,
                    label: this.$translate.instant('LABEL_CURRENCY_AMOUNT', { currencySymbol: this.currencySymbol })
                },
                { value: GoalInputTypeEnum.Numeric, label: 'LABEL_UNITS' }
            ];
            
        }

        public setNumberLabels() {
            this.calculatePlusMinus(this.goal, this.actual);

            switch (this.numberDisplayType) {

                case GoalInputTypeEnum.Numeric:
                case GoalInputTypeEnum.Currency:

                    if (!this.isValidData(this.actual)) {
                        this.actualText = '0'
                    }
                    else if (this.isValidData(this.actual)) {
                        this.actualText = this.actual.toFixed(1).toString();
                    }
                    else {
                        this.actualText = '-';
                    }

                    if (!_.isUndefined(this.goal) && !_.isUndefined(this.goal) && !_.isNaN(this.goal) && !_.isNull(this.goal)) {
                        this.goalText = this.goal.toFixed(1).toString();
                    }
                    else {
                        this.goalText = '-';
                    }

                    break;

                case GoalInputTypeEnum.Percentage:

                    if (!this.isValidData(this.actual)) {
                        this.actualText = '0%'
                    }
                    else if (this.isValidData(this.actual)) {
                        this.actualText = (this.actual * 100).toFixed(0) + '%';
                    }
                    else {
                        this.actualText = '-';
                    }

                    if (!this.isValidData(this.goal)) {
                        this.goalText = '-';
                    }
                    else if (this.isValidData(this.goal)) {
                        this.goalText = (this.goal * 100).toFixed(0) + '%';
                    }

                    break;

                default:
                    break;
            }
        }

        public isMobile = false;
        public innerWidth = 0;

        $onInit = () => {
            this.setTileDateRanges()
            this.innerWidth = window.innerWidth;

            this.isMobile = window.innerWidth <= 450;
            this.$scope.$watch(() => this.currentGoalsModel, (value) => {
                if (!value) return;

                this.redrawChart();
                this.setNumberLabels();
               
            });

            this.$scope.$watch(() => this.globalSelectedDateRange, (value) => {
                if (_.isUndefined(value)) return;

                this.changeSelectedDateRange();
                this.redrawChart();
                this.setNumberLabels();
            });

            this.$scope.$on('RESET_DATE_RANGE', () => {
                this.changeSelectedDateRange();

            });
        }

        private isValidData(num: number): boolean {
            return (!_.isUndefined(num) && !_.isUndefined(num) && !_.isNaN(num) && !_.isNull(num))
        }

        private setTileDateRanges() {

            switch (this.goalsCategory) {
                case GoalCategoryEnum.Service:
                case GoalCategoryEnum.Retail:
                case GoalCategoryEnum.GiftCard:
                    this.selectedDateRangeList = [];
                    GoalCategoriesDateRanges.sales.forEach(arrItem => {
                        let elem: DateRangeListItem = GoalDateRanges.find(item => item.value === arrItem)
                        this.selectedDateRangeList.push(elem);
                    });
                    this.salesDateRangeList = this.selectedDateRangeList;
                    break;
                case GoalCategoryEnum.AverageTicket:
                    this.selectedDateRangeList = [];
                    GoalCategoriesDateRanges.averageTicket.forEach(arrItem => {
                        let elem: DateRangeListItem = GoalDateRanges.find(item => item.value === arrItem)
                        this.selectedDateRangeList.push(elem);
                    });
                    this.averageTicketDateRangeList = this.selectedDateRangeList;
                    break;
                case GoalCategoryEnum.NewClientRetention:
                case GoalCategoryEnum.RepeatClientRetention:
                    this.selectedDateRangeList = [];
                    GoalCategoriesDateRanges.retention.forEach(arrItem => {
                        let elem: DateRangeListItem = GoalDateRanges.find(item => item.value === arrItem)
                        this.selectedDateRangeList.push(elem);
                    });
                    this.retentionDateRangeList = this.selectedDateRangeList;
                    break;
                case GoalCategoryEnum.Rating:
                case GoalCategoryEnum.NewClientsPerMonth:
                case GoalCategoryEnum.FrequencyOfVisit:
                    this.selectedDateRangeList = [];
                    GoalCategoriesDateRanges.ratings.forEach(arrItem => {
                        let elem: DateRangeListItem = GoalDateRanges.find(item => item.value === arrItem)
                        this.selectedDateRangeList.push(elem);
                    });
                    this.ratingsDateRangeList = this.selectedDateRangeList;
                    break;
                case GoalCategoryEnum.Productivity:
                    this.selectedDateRangeList = [];
                    GoalCategoriesDateRanges.productivity.forEach(arrItem => {
                        let elem: DateRangeListItem = GoalDateRanges.find(item => item.value === arrItem)
                        this.selectedDateRangeList.push(elem);
                    });
                    this.productivityDateRangeList = this.selectedDateRangeList;
                    break;
                case GoalCategoryEnum.Rebook:
                    this.selectedDateRangeList = [];
                    GoalCategoriesDateRanges.rebook.forEach(arrItem => {
                        let elem: DateRangeListItem = GoalDateRanges.find(item => item.value === arrItem)
                        this.selectedDateRangeList.push(elem);
                    });
                    this.rebookDateRangeList = this.selectedDateRangeList;
                    break;
                case GoalCategoryEnum.RequestRate:
                    this.selectedDateRangeList = [];
                    GoalCategoriesDateRanges.RequestRate.forEach(arrItem => {
                        let elem: DateRangeListItem = GoalDateRanges.find(item => item.value === arrItem)
                        this.selectedDateRangeList.push(elem);
                    });
                    this.ratesDateRangeList = this.selectedDateRangeList;
                    break;
                case GoalCategoryEnum.Membership:
                    this.selectedDateRangeList = [];
                    GoalCategoriesDateRanges.rates.forEach(arrItem => {
                        let elem: DateRangeListItem = GoalDateRanges.find(item => item.value === arrItem)
                        this.selectedDateRangeList.push(elem);
                    });
                    this.ratesDateRangeList = this.selectedDateRangeList;
                    break;
            }
        }        

        private calculatePlusMinus(numGoal: number, numActual: number) {

            this.differenceText = '100%';
            let difference: number = 0;
            this.smallerFont = false;

            if (numGoal > 0 && this.isValidData(numGoal) && this.isValidData(numActual) && numActual > 0) {
                difference = Math.abs(numGoal - numActual);
                this.percentUpDown = difference / numGoal;
                this.differenceText = (this.percentUpDown * 100).toFixed(0) + '%';
                this.smallerFont = this.differenceText.length > 3;
            }

        }

        public redrawIndividualChart() {

            if (_.isFunction(this.onDateRangeSelection)) {
                this.onDateRangeSelection({
                    data: {
                        goalCategory: this.goalsCategory,
                        goalDateRange: this.selectedDateRange.value
                    }
                });
            }

            this.redrawChart();
        }

        public redrawChart(defaultRange?: boolean) {
            let defaultDateRange: GoalDateRangeEnum;
            
            let chartClass: string = '.'.concat(this.chartClass);

            if (!_.isUndefined(this.currentGoalsModel) && !_.isUndefined(this.selectedDateRange) && !_.isUndefined(this.goalsCategory)) {
                                   
                switch (this.goalsCategory) {
                    case GoalCategoryEnum.GiftCard:
                    case GoalCategoryEnum.Retail:
                    case GoalCategoryEnum.Service:
                        if (this.selectedDateRange.value === GoalDateRangeEnum.YearToDate ||
                            this.selectedDateRange.value === GoalDateRangeEnum.LastTwelveMonths ||
                            (this.selectedDateRange.value === GoalDateRangeEnum.SpecificYear && this.goalsCategory !== GoalCategoryEnum.GiftCard) ||
                            ((this.selectedDateRange.value === GoalDateRangeEnum.ThisWeek ||
                            this.selectedDateRange.value === GoalDateRangeEnum.LastWeek) && this.goalsCategory !== GoalCategoryEnum.GiftCard)) {

                            var groupedSalesItem = _.find(this.currentGoalsModel["sales"], (item: any) => { return (item.dateRangeEnum == (defaultRange ? defaultDateRange : this.selectedDateRange.value) && item.goalCategory == this.goalsCategory) });
                            let salesMonthlyData;
                            let tileWidth = 2000;
                            if (this.selectedDateRange.value === GoalDateRangeEnum.ThisWeek || this.selectedDateRange.value === GoalDateRangeEnum.LastWeek) {
                                tileWidth = 900;
                            }

                            if (this.measurement == 0) {
                                salesMonthlyData = this.getBreakdownData('sales', this.selectedDateRange.value, this.$translate, GoalInputTypeEnum.Currency, true, this.goalsCategory);
                                this.createGroupedBarChart(salesMonthlyData, chartClass, tileWidth, GoalInputTypeEnum.Currency);
                                this.goal = groupedSalesItem ? groupedSalesItem.amount : 0;
                                this.actual = groupedSalesItem ? groupedSalesItem.actualAmount : 0;
                            } else {
                                salesMonthlyData = this.getBreakdownData('sales', this.selectedDateRange.value, this.$translate, GoalInputTypeEnum.Numeric, true, this.goalsCategory);
                                this.createGroupedBarChart(salesMonthlyData, chartClass, tileWidth);
                                this.goal = groupedSalesItem ? groupedSalesItem.unit : 0;
                                this.actual = groupedSalesItem ? groupedSalesItem.actualUnit : 0;
                            }

                        } else {
                            let salesItem = _.find(this.currentGoalsModel["sales"], (item: any) => { return (item.dateRangeEnum == (defaultRange ? defaultDateRange : this.selectedDateRange.value) && item.goalCategory == this.goalsCategory) });

                            if (this.measurement == 0) {
                                this.goal = salesItem ? salesItem.amount : 0;
                                this.actual = salesItem ? salesItem.actualAmount : 0;
                            } else {
                                this.goal = salesItem ? salesItem.unit : 0;
                                this.actual = salesItem ? salesItem.actualUnit : 0;
                            }

                            this.dateRangeText = this.getDateRangeText(this.selectedDateRange);
                            this.dashboardGoalsLogic.createBarChart(this.goal, this.actual, chartClass);
                        }

                        break;
                    case GoalCategoryEnum.FrequencyOfVisit:
                        let frequencyOfVisitItem = _.find(this.currentGoalsModel["frequencyOfVisit"], (item: any) => { return (item.dateRangeEnum == this.selectedDateRange.value && item.goalCategory == this.goalsCategory) });
                        
                        this.goal = frequencyOfVisitItem ? frequencyOfVisitItem.amount : 0;
                        this.actual = frequencyOfVisitItem ? frequencyOfVisitItem.actualAmount : 0;

                        this.dashboardGoalsLogic.createBarChart(this.goal, this.actual, chartClass);

                        break;
                    case GoalCategoryEnum.Membership:
                        if (this.selectedDateRange.value === GoalDateRangeEnum.YearToDate) {
                            let membershipMonthlyData = this.getBreakdownData('membership', this.selectedDateRange.value, this.$translate, GoalInputTypeEnum.Numeric, true);

                            var groupedMembershipItem = _.find(this.currentGoalsModel["membership"], (item: any) => { return (item.dateRangeEnum == (defaultRange ? defaultDateRange : this.selectedDateRange.value) && item.goalCategory == this.goalsCategory) });
                            this.goal = groupedMembershipItem ? groupedMembershipItem.unit : 0;
                            this.actual = groupedMembershipItem ? groupedMembershipItem.actualUnit : 0;

                            this.createGroupedBarChart(membershipMonthlyData, chartClass, 550);
                        } else {
                            let membershipItem = _.find(this.currentGoalsModel["membership"], (item: any) => { return (item.dateRangeEnum == this.selectedDateRange.value && item.goalCategory == this.goalsCategory) });

                            this.goal = membershipItem ? membershipItem.unit : 0;
                            this.actual = membershipItem ? membershipItem.actualUnit : 0;

                            this.dashboardGoalsLogic.createBarChart(this.goal, this.actual, chartClass);
                        }

                        break;
                    case GoalCategoryEnum.NewClientsPerMonth:
                        if (this.selectedDateRange.value === GoalDateRangeEnum.LastTwelveMonths || this.selectedDateRange.value === GoalDateRangeEnum.YearToDate) {
                            let newClientMonthlyData = this.getBreakdownData('newClient', this.selectedDateRange.value, this.$translate, GoalInputTypeEnum.Numeric, true);

                            var groupedNewClientsItem = _.find(this.currentGoalsModel["newClient"], (item: any) => { return (item.dateRangeEnum == (defaultRange ? defaultDateRange : this.selectedDateRange.value) && item.goalCategory == this.goalsCategory) });
                            this.goal = groupedNewClientsItem ? groupedNewClientsItem.unit : 0;
                            this.actual = groupedNewClientsItem ? groupedNewClientsItem.actualUnit : 0;

                            this.createGroupedBarChart(newClientMonthlyData, chartClass, 550);
                        } else {
                            let newClientsItem = _.find(this.currentGoalsModel["newClient"], (item: any) => { return (item.dateRangeEnum == this.selectedDateRange.value && item.goalCategory == this.goalsCategory) });

                            this.goal = newClientsItem ? newClientsItem.unit : 0;
                            this.actual = newClientsItem ? newClientsItem.actualUnit : 0;

                            this.dashboardGoalsLogic.createBarChart(this.goal, this.actual, chartClass);
                        }

                        break;
                    case GoalCategoryEnum.Rebook:
                        if (this.selectedDateRange.value === GoalDateRangeEnum.YearToDate) {
                            let rebookMonthlyData = this.getBreakdownData('rebook', this.selectedDateRange.value, this.$translate, GoalInputTypeEnum.Percentage, true);

                            var groupedRebookItem = _.find(this.currentGoalsModel["rebook"], (item: any) => { return (item.dateRangeEnum == (defaultRange ? defaultDateRange : this.selectedDateRange.value) && item.goalCategory == this.goalsCategory) });
                            this.goal = groupedRebookItem ? groupedRebookItem.percent : 0;
                            this.actual = groupedRebookItem ? groupedRebookItem.actualPercent : 0;

                            this.createTwelveMonthChartNew(rebookMonthlyData, chartClass, GoalInputTypeEnum.Percentage, 2);
                        } else {
                            let clientRebookItem = _.find(this.currentGoalsModel["rebook"], (item: any) => { return (item.dateRangeEnum == (defaultRange ? defaultDateRange : this.selectedDateRange.value) && item.goalCategory == this.goalsCategory) });

                            this.goal = clientRebookItem ? clientRebookItem.percent : 0;
                            this.actual = clientRebookItem ? clientRebookItem.actualPercent : 0;

                            this.dashboardGoalsLogic.createDonutChart(this.goal, this.actual, chartClass);
                        }

                        break;
                    case GoalCategoryEnum.RequestRate:
                        if (this.selectedDateRange.value === GoalDateRangeEnum.YearToDate || this.selectedDateRange.value === GoalDateRangeEnum.LastTwelveMonths) {
                            let requestRateMonthlyData = this.getBreakdownData('requestRate', this.selectedDateRange.value, this.$translate, GoalInputTypeEnum.Percentage, true);

                            var groupedRequestRateItem = _.find(this.currentGoalsModel["requestRate"], (item: any) => { return (item.dateRangeEnum == (defaultRange ? defaultDateRange : this.selectedDateRange.value) && item.goalCategory == this.goalsCategory) });
                            this.goal = groupedRequestRateItem ? groupedRequestRateItem.percent : 0;
                            this.actual = groupedRequestRateItem ? groupedRequestRateItem.actualPercent : 0;

                            this.createTwelveMonthChartNew(requestRateMonthlyData, chartClass, GoalInputTypeEnum.Percentage, 2);
                        } else {
                            let requestRateItem = _.find(this.currentGoalsModel["requestRate"], (item: any) => { return (item.dateRangeEnum == (defaultRange ? defaultDateRange : this.selectedDateRange.value) && item.goalCategory == this.goalsCategory) });

                            this.goal = requestRateItem ? requestRateItem.percent : 0;
                            this.actual = requestRateItem ? requestRateItem.actualPercent : 0;

                            this.dashboardGoalsLogic.createDonutChart(this.goal, this.actual, chartClass);
                        }

                        break;
                    case GoalCategoryEnum.NewClientRetention:
                    case GoalCategoryEnum.RepeatClientRetention:
                        let retentionItem = _.find(this.currentGoalsModel["retention"], (item: any) => { return (item.dateRangeEnum == (defaultRange ? defaultDateRange : this.selectedDateRange.value) && item.goalCategory == this.goalsCategory) });
                            
                        this.goal = retentionItem ? retentionItem.percent : 0;
                        this.actual = retentionItem ? retentionItem.actualPercent : 0;
                            
                        this.dashboardGoalsLogic.createDonutChart(this.goal, this.actual, chartClass);

                        break;
                    case GoalCategoryEnum.Rating:
                        if (this.selectedDateRange.value === GoalDateRangeEnum.LastTwelveMonths || this.selectedDateRange.value === GoalDateRangeEnum.YearToDate) {
                            let fiveStarMonthlyData = this.getBreakdownData('fiveStarRating', this.selectedDateRange.value, this.$translate, GoalInputTypeEnum.Currency, true);

                            var groupedRatingItem = _.find(this.currentGoalsModel["fiveStarRating"], (item: any) => { return (item.dateRangeEnum == (defaultRange ? defaultDateRange : this.selectedDateRange.value) && item.goalCategory == this.goalsCategory) });
                            this.goal = groupedRatingItem ? groupedRatingItem.amount : 0;
                            this.actual = groupedRatingItem ? groupedRatingItem.actualAmount : 0;

                            this.createGroupedBarChart(fiveStarMonthlyData, chartClass, 550);
                        } else {
                            let fivestarItem = _.find(this.currentGoalsModel["fiveStarRating"], (item: any) => { return (item.dateRangeEnum == this.selectedDateRange.value && item.goalCategory == this.goalsCategory) });

                            this.goal = fivestarItem ? fivestarItem.amount : 0;
                            this.actual = fivestarItem ? fivestarItem.actualAmount : 0;
                            this.dashboardGoalsLogic.createBarChart(this.goal, this.actual, chartClass);
                        }
                        
                        break;
                    case GoalCategoryEnum.Productivity:
                        if (this.selectedDateRange.value === GoalDateRangeEnum.LastTwelveMonths || this.selectedDateRange.value === GoalDateRangeEnum.YearToDate || this.selectedDateRange.value === GoalDateRangeEnum.SpecificYear || this.selectedDateRange.value === GoalDateRangeEnum.ThisWeek || this.selectedDateRange.value === GoalDateRangeEnum.LastWeek) {
                            var groupedProductivityItem = _.find(this.currentGoalsModel["productivity"], (item: any) => { return (item.dateRangeEnum == (defaultRange ? defaultDateRange : this.selectedDateRange.value) && item.goalCategory == this.goalsCategory) });

                            this.goal = groupedProductivityItem ? groupedProductivityItem.percent : 0;
                            this.actual = groupedProductivityItem ? groupedProductivityItem.actualPercent : 0;

                            this.productivityGoalsData = this.getBreakdownData('productivity', this.selectedDateRange.value, this.$translate, GoalInputTypeEnum.Percentage, true, this.goalsCategory);
                            
                        } else {
                            let productivityItem = _.find(this.currentGoalsModel["productivity"], (item: any) => { return (item.dateRangeEnum == (defaultRange ? defaultDateRange : this.selectedDateRange.value) && item.goalCategory == this.goalsCategory) });

                            this.goal = productivityItem ? productivityItem.percent : 0;

                            this.productivityGoalsData = [{
                                label: this.$translate.instant(this.selectedDateRange.label),
                                goal: this.goal ? +(this.goal * 100).toFixed(0) : 0,
                                actual: productivityItem ? +(productivityItem.actualPercent * 100).toFixed(2) : 0,
                                year: productivityItem ? productivityItem.year : this.globalSelectedYear
                            }];
                        }

                        if (this.productivityGoalsData.length > 0) this.createTwelveMonthChartNew(this.productivityGoalsData, chartClass, GoalInputTypeEnum.Percentage, 1);
                        
                        break;
                    default:
                        break;
                }
            } else {
                // draw default charts
                switch (this.goalsCategory) {
                    case GoalCategoryEnum.NewClientsPerMonth:
                        this.dashboardGoalsLogic.createGaugeChart(0, 0, chartClass);
                        break;
                    case GoalCategoryEnum.Retail:
                    case GoalCategoryEnum.Service:
                    case GoalCategoryEnum.GiftCard:
                    case GoalCategoryEnum.AverageTicket:
                        this.dashboardGoalsLogic.createBarChart(0, 0, chartClass);
                        break;
                    case GoalCategoryEnum.Rebook:
                    case GoalCategoryEnum.RequestRate:
                    case GoalCategoryEnum.RepeatClientRetention:
                    case GoalCategoryEnum.NewClientRetention:
                        this.dashboardGoalsLogic.createDonutChart(0, 0, chartClass);
                        break;
                    case GoalCategoryEnum.Rating:
                        this.showFiveStarRating(0);
                        break;
                    case GoalCategoryEnum.Productivity:
                        let emptyProductivityGoalsData: IMonthlyBarChartItem[] = [];

                        emptyProductivityGoalsData.push({
                            "label": 'Today',
                            "goal": undefined,
                            "actual": undefined,
                            "year": 0
                        })

                        this.createTwelveMonthChartNew(emptyProductivityGoalsData, chartClass, GoalInputTypeEnum.Percentage, 1);
                        break;
                    default:
                        break;
                }
            }

            this.setNumberLabels();
        }

        getBreakdownData(chartName: string, chartDateRange: GoalDateRangeEnum, $translate: ng.translate.ITranslateService, inputType: GoalInputTypeEnum, hasMonthly?: boolean, chartCategory?: GoalCategoryEnum): IMonthlyBarChartItem[] {
            const key = INPUT_TYPE_KEY[inputType];
            const isMonthly = hasMonthly && (chartDateRange === GoalDateRangeEnum.YearToDate || chartDateRange === GoalDateRangeEnum.LastTwelveMonths || (chartDateRange === GoalDateRangeEnum.SpecificYear && (chartCategory === GoalCategoryEnum.Service || chartCategory === GoalCategoryEnum.Retail || chartCategory === GoalCategoryEnum.Productivity)));
            const isWeekly = (chartDateRange === GoalDateRangeEnum.LastWeek || chartDateRange === GoalDateRangeEnum.ThisWeek) && (chartCategory === GoalCategoryEnum.Service || chartCategory === GoalCategoryEnum.Retail || chartCategory === GoalCategoryEnum.Productivity);
            let list: IDashboardGoalColumn;

            if (chartCategory) {
                list = this.currentGoalsModel[chartName].find(goal => goal.dateRangeEnum === chartDateRange && goal.goalCategory === chartCategory);
            } else {
                list = this.currentGoalsModel[chartName].find(goal => goal.dateRangeEnum === chartDateRange);
            }

            switch (inputType) {
                case GoalInputTypeEnum.Percentage:
                    this.goal = list ? list.percent : 0;
                    break;
                case GoalInputTypeEnum.Numeric:
                    this.goal = list ? list.unit : 0;
                    break;
                default:
                    this.goal = list ? list.amount : 0;
                    break;
            }

            if (list) {
                return (list.goalDashboardBreakdown || [])
                    .sort((a: IDashboardGoalColumn, b: IDashboardGoalColumn) => a.year - b.year || a.month - b.month)
                    .reduce((all, item: IGoalColumn) => {
                        if (isMonthly && item.month === 0 && !isWeekly) {
                            return all;
                        }
                        let temp = `actual${key.slice(0, 1).toUpperCase() + key.slice(1)}`;
                        let actualValue = item[temp] || 0;
                        let value = item[key] ? item[key].toFixed(2) : 0;

                        if (inputType === GoalInputTypeEnum.Percentage) {

                            value = value * 100;

                            if (chartCategory === GoalCategoryEnum.Productivity) {
                                actualValue = (actualValue * 100).toFixed(2);
                            } else {
                                actualValue = (actualValue * 100).toFixed(0);
                            }
                            
                        }
                        else if (inputType == GoalInputTypeEnum.Numeric) {
                            actualValue = item.actualUnit || 0;
                            value = item.unit || 0;
                        }
                        let label: string;
                        label = `${$translate.instant(LABEL_MONTH[item.month - 1]).slice(0, 3)}`;

                        if (item.goalDate && isWeekly) {
                            label = moment(item.goalDate).format('ddd, MMM Do');
                        }

                        all.push({
                            label: isMonthly || isWeekly ? label : `${$translate.instant(this.selectedDateRange.label)}`,
                            goal: value,
                            actual: actualValue,
                            year: item.year
                        });

                        return all;
                    }, []);
            } else {
                return [];
            }
            
        }

        public getDateRangeText = (dateRangeSelected: DateRangeListItem) => {
            let value: string = '';
            
            switch (dateRangeSelected.value) {
                case GoalDateRangeEnum.Today: {
                    value = moment().format("MMM Do YYYY");
                    break;
                }
                case GoalDateRangeEnum.Yesterday: {
                    value = moment().subtract(1, 'days').calendar();
                    break;
                }
                default: {
                    value = dateRangeSelected.label;
                    break;
                }
            }

            return value;
        }

        public changeMeasurement(): void {
            if (!this.currentGoalsModel) {
                return;
            }

            this.salesData = this.dashboardGoalsLogic.barChartMapFn(
                this.currentGoalsModel.sales,
                this.salesDateRange,
                this.$translate,
                this.measurement
            );
            this.numberDisplayType = this.measurement;
            this.redrawChart();

        }

        showFiveStarRating = (numActual: number) => {

            if (this.stars.length > 0) {
                this.stars = [];
                d3.selectAll('.star').remove();
            }

            if (_.isUndefined(numActual) || _.isNull(numActual) || _.isNaN(numActual)) {
                numActual = 0;
            }
            let ratingWholeNumber = Math.floor(numActual) || 0;
            let remainder = numActual - ratingWholeNumber;
            let unfilledWholeNumber = 5 - Math.ceil(numActual);

            for (var i = 0; i < ratingWholeNumber; i++) {
                this.stars.push({ type: 'whole' });
            }

            if (remainder >= 0.75) {
                this.stars.push({ type: 'three-quarter' });
            } else if (remainder >= 0.5) {
                this.stars.push({ type: 'half' });
            } else if (remainder < 0.5 && remainder > 0) {
                this.stars.push({ type: 'quarter' });
            }

            if (_.isUndefined(numActual) || _.isNaN(numActual) || numActual == 0) {
                for (var i = 0; i < 5; i++) {
                    this.stars.push({ type: 'unfilled' });
                }
            }
            else {
                for (var i = 0; i < unfilledWholeNumber; i++) {
                    this.stars.push({ type: 'unfilled' });
                }
                setTimeout(() => {
                    var starsToFadeIn = document.querySelectorAll('.star.no-opacity');
                    for (var i = 0; i < starsToFadeIn.length; i++) {
                        starsToFadeIn[i].className += ' show-opacity';
                    }
                }, 250)
            }

        }

        createTwelveMonthChartNew = (data: IMonthlyBarChartItem[], className: string, displayType: GoalInputTypeEnum, tileType: number) => {
            let currentSelectedYear = this.globalSelectedYear;
            let currentYear = new Date().getFullYear();
            let previousYear = (currentSelectedYear ? currentSelectedYear : currentYear) - 1;
            let nextYear = currentSelectedYear + 1;
            let currentMonth = new Date().getMonth();
            let lastYearMonths = 12 - currentMonth - 1; //the 1 is because last 12 months doesnt count current month
            let currentYearMonths = 12 - lastYearMonths;
 
            let svgWidth: number = 0;
            let svgHeight: number = 300;
            let chartGoal = data.length > 0 && data[data.length - 1].goal ? data[data.length - 1].goal : 0;
            let otherYearGoal = -1;
            let nextYearGoal = -1;
            let duration: number = 800;
            let actualBarColor: string = "#72b8ff";
            let otherYearActualColor: string = "#ea9c33";
            let currentGoalLineColor: string = "#72b8ff";
 
            let metricLabel = '';
            let previousYearActualColor = '#ea9c33';
           
            switch (displayType) {
                case GoalInputTypeEnum.Percentage:
                    metricLabel = '%';
                    break;
                case GoalInputTypeEnum.Currency:
                case GoalInputTypeEnum.Numeric:
                case GoalInputTypeEnum.Float:
                    break;
            }

            if (data.length < 3) {//took out || this.mobile
                svgWidth = 350;
            } else if (tileType == 2) {
                svgWidth = 450;
            } else {
                svgWidth = 900;
            }

            var container = d3.select(className),
                width = svgWidth,
                margin = { top: 100, right: 15, bottom: 50, left: 50 },
                barPadding = .2,
                axisTicks = { qty: 5, outerSize: 5, dateFormat: '%m-%d' },
                emptyValueHeight = 2,
                emptyValueY = svgHeight - margin.bottom - margin.top - emptyValueHeight;

            var svg: any;
            var yAxisContainer: any;
            if (container.select('svg').empty()) {

                yAxisContainer = container.append("div")
                    .attr("id", `${className} id`)
                    .style("overflow-x", "auto")
                    .style("-webkit-overflow-scrolling", "touch")

                svg = yAxisContainer.append("svg")
                    .attr("viewBox", `0 0 ${width} ${svgHeight}`)
                    .attr("width", width)
                    .attr("height", svgHeight)
                    .append("g")
                    .attr("transform", `translate(${margin.left},${margin.top})`);
            }
            else {
                container.select('svg').remove();
                container.select('div').remove();

                yAxisContainer = container.append("div")
                    .attr("id", `${className} id`)
                    .style("overflow-x", "auto")
                    .style("-webkit-overflow-scrolling", "touch")

                svg = yAxisContainer.append("svg")
                    .attr("viewBox", `0 0 ${width} ${svgHeight}`)
                    .attr("width", width)
                    .attr("height", svgHeight)
                    .append("g")
                    .attr("transform", `translate(${margin.left},${margin.top})`);
            }
            
            const xScale = d3.scaleBand()
                .range([0, width - margin.left - margin.right])
                .padding(barPadding)
                .domain(data.map((s) => s.label)).padding(0.2);

            var xAxis = d3.axisBottom(xScale).tickSizeOuter(axisTicks.outerSize);
            
            let maxValue = 0;
            if (displayType == GoalInputTypeEnum.Percentage) {

                maxValue = d3.max(data, d => {
                    return (d.actual > +d.goal ? d.actual : 100)
                });
            }
            else {
                maxValue = d3.max(data, d => {
                    return (d.actual > d.goal ? d.actual : d.goal)
                });
            }
            const yScale = d3.scaleLinear()
                .range([svgHeight - margin.top - margin.bottom, 0])
                .domain([0, maxValue]);

            var yAxis = d3.axisLeft(yScale).ticks(axisTicks.qty).tickSizeOuter(axisTicks.outerSize);

            const barGroups = svg.selectAll()
                .data(data)
                .enter()
                .append('g');

            barGroups
                .append('rect')
                .attr('class', 'bar')
                .style("fill", d => {
                    return d.year == currentYear ? actualBarColor : previousYearActualColor
                })
                .attr('x', (g) => xScale(g.label))
                .attr("y", yScale(0) - 2)
                .attr("height", 2)
                .attr('width', xScale.bandwidth())
                .transition()
                .delay((d) => {
                    if (d.year == previousYear)
                        otherYearGoal = d.goal;
                    else if (d.year == nextYear) {
                        nextYearGoal = d.goal;
                    }
                    return d.actual > 0 ? 200 : 0;
                })
                .duration((d) => {
                    return d.actual > 0 ? duration : 0;
                })
                .attr("y", d => {
                    return d.actual > 0 ? yScale(d.actual) : emptyValueY
                })
                .attr("height", d => {

                    return d.actual > 0 ? (svgHeight - margin.top - margin.bottom - yScale(d.actual)) : emptyValueHeight;
                })
            // removed dashed lines due to US 35069
            /*if (this.selectedDateRange.value === 10) {
                // Checks if its the last 12 months
                //if (otherYearGoal > 0) {
                svg.append('line')
                    .attr('class', 'previous-goal-line')
                    .attr('x1', 5)
                    .attr('x2', ((width - margin.right + margin.left) * lastYearMonths / 12))
                    .attr('y1', yScale(otherYearGoal))
                    .attr('y2', yScale(otherYearGoal))
                
                //}
                if (!_.isUndefined(chartGoal) && chartGoal > 0) {
                    svg.append('line')
                        .attr('class', 'goal-line')
                        .attr('x1', ((width - margin.right + margin.left) * lastYearMonths / 12))
                        .attr('x2', (width))
                        .attr('y1', yScale(chartGoal))
                        .attr('y2', yScale(chartGoal))
                }

            }
            else {
                if (!_.isUndefined(chartGoal) && chartGoal > 0) {
                    svg.append('line')
                        .attr('class', 'goal-line')
                        .attr('x1', (3))
                        .attr('x2', (width))
                        .attr('y1', yScale(chartGoal))
                        .attr('y2', yScale(chartGoal))
                }
            }*/


            barGroups
                .append('text')
                .attr('opacity', 0)
                .attr('class', 'value')
                .attr('x', (a) => xScale(a.label) + xScale.bandwidth() / 2)
                .attr("y", d => {
                    return (d.actual > 0 ? (yScale(d.actual) - 8) : (emptyValueY - 8))
                })
                .attr("height", d => {
                    return d.actual > 0 ? (svgHeight - margin.top - margin.bottom - yScale(d.actual) + 8) : (emptyValueHeight + 8);
                })
                .attr('text-anchor', 'middle')
                .text((a) => `${a.actual}` + metricLabel)
                .transition()
                .duration((d) => {
                    return d.actual > 0 ? duration : 0;
                })
                .attr('opacity', 1);

            // Add the X Axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", `translate(0,${svgHeight - margin.top - margin.bottom})`)
                .call(xAxis);

            // Add the Y Axis
            svg.append("g")
                .attr("class", "y axis")
                .call(yAxis);

            let legend_labels = [currentSelectedYear ? currentSelectedYear : currentYear];
            let colorList = [currentGoalLineColor];

            if (this.selectedDateRange && this.selectedDateRange.value == GoalDateRangeEnum.LastTwelveMonths) {
                legend_labels = [];
                colorList = [];
            }
            
            var color = d3.scaleLinear()
                .domain(legend_labels)
                .range(colorList);

            var legend = svg.selectAll("g.legend")
                .data(legend_labels)
                .enter().append("g")
                .attr("class", "legend")
                .attr('transform', 'translate(0,0)');

            var ls_w = 20, ls_h = 20;

            legend.append("line")
                .attr("x1", width - margin.right - 120)
                .attr("x2", width - margin.right - 85)
                .attr("y1", function (d, i) { return (i * ls_h) - (2 * ls_h) - 5; })
                .attr("y2", function (d, i) { return (i * ls_h) - (2 * ls_h) - 5; })
                .attr("class", "")
                .style("stroke", function (d, i) { return color(d); })
                .style("stroke-width", 1)
                .style("stroke-dasharray", "2% 1%");

            legend.append("text")
                .attr("x", width - margin.right - 75)
                .attr("y", function (d, i) { return (i * ls_h) - 2 * ls_h; })
                .text(function (d, i) { return legend_labels[i]; });
            
        }

        createGroupedBarChart = (models: IMonthlyBarChartItem[], className: string, tileWidth: number, displayType?: GoalInputTypeEnum) => {
            let svgWidth: number = 0;
            let svgHeight: number = 250;
            let duration: number = 800;
            let actualBarColor: string = "#72b8ff";
            let goalBarColor: string = '#eaeaea';
            let previousYearActualColor = '#ea9c33';
            let barSize = 75;
            let metricLabel = '';

            if (displayType === GoalInputTypeEnum.Percentage) metricLabel = '%';
            if (displayType === GoalInputTypeEnum.Currency) metricLabel = `${this.currencySymbol}`;

            svgWidth = Math.min(models.length * 200, tileWidth);
            
            if (models.length <= 3 || this.isMobile) {
               //svgWidth = 500;
            }

            var container = d3.select(className),
                width = svgWidth,
                margin = { top: 20, right: 5, bottom: 30, left: 80 },
                barPadding = .2,
                axisTicks = { qty: 5, outerSize: 0, dateFormat: '%m-%d' },
                emptyValueHeight = 2,
                emptyValueY = svgHeight - margin.bottom - margin.top - emptyValueHeight;
            
            var svg: any;
            var yAxisContainer: any;
           
            if (container.select('svg').empty()) {
                yAxisContainer = container.append("div")
                    .attr("id", `${className} id`)
                    .style("overflow-x", "auto")
                    .style("-webkit-overflow-scrolling", "touch")

                svg = yAxisContainer.append("svg")
                    .attr("viewBox", `0 0 ${width} ${svgHeight}`)
                    .attr("width", width)
                    .attr("height", svgHeight)
                    .append("g")
                    .attr("transform", `translate(${margin.left},${margin.top})`);
            }
            else {
                container.select('svg').remove();
                container.select('div').remove();
           
                yAxisContainer = container.append("div")
                    .attr("id",`${className} id`)
                    .style("overflow-x", "auto")
                    .style("-webkit-overflow-scrolling", "touch")
                  
                 svg = yAxisContainer.append("svg")
                     .attr("viewBox", `0 0 ${width} ${svgHeight}`)
                     .attr("width", width)
                    .attr("height", svgHeight)
                    .append("g")
                    .attr("transform", `translate(${margin.left},${margin.top})`);
            }
            var xScale0 = d3.scaleBand().range([0, width - margin.left - margin.right]).padding(barPadding);
            var xScale1 = d3.scaleBand();
            var yScale = d3.scaleLinear().range([svgHeight - margin.top - margin.bottom, 0]);
            var xAxis = d3.axisBottom(xScale0).tickSizeOuter(axisTicks.outerSize);
            var yAxis = d3.axisLeft(yScale).ticks(axisTicks.qty).tickSizeOuter(axisTicks.outerSize);
            
            xScale0.domain(models.map(d => d.label));
            xScale1.domain(['goal', 'actual']).range([0, xScale0.bandwidth()]);
            yScale.domain([0, 100]);
            yScale.domain([0, d3.max(models, d => d.actual > d.goal ? d.actual : d.goal)]);

            if (width < 900) {
                //barSize = xScale1.bandwidth();
            }

            const barGroups = svg.selectAll()
                .data(models)
                .enter()
                .append('g')
            var model_name = svg.selectAll(".model_name")
                .data(models)
                .enter().append("g")
                .attr("class", "model_name")
                .attr("transform", d => `translate(${xScale0(d.label)},0)`);

            /* Add field2 bars */
            model_name.selectAll(".bar.field2")
                .data(d => [d])
                .enter()
                .append("rect")
                .attr("class", "bar field2")
                .style("fill", d => {
                    return d.year == new Date().getFullYear() ? actualBarColor : previousYearActualColor
                })
                
                .attr("x", d => xScale1('actual'))
                .attr("y", yScale(0) - 2)
                .attr("height", 2)
                .attr("width", xScale1.bandwidth())
                .transition()
                .delay((d) => {
                    return d.actual > 0 ? 200 : 0;
                })
                .duration((d) => {
                    return d.actual > 0 ? duration : 0;
                })
                .attr("y", d => {
                    return d.actual > 0 ? yScale(d.actual) : emptyValueY
                })
                .attr("height", d => {
                    
                    return d.actual > 0 ? (svgHeight - margin.top - margin.bottom - yScale(d.actual)) : emptyValueHeight;
                })

                
            barGroups.selectAll(".bar.field2")
                .data(d => [d])
                .enter()
                .append('text')
                .attr('opacity', 0)
                .attr('class', 'value')
                .attr('x', (a) => xScale0(a.label) + xScale1.bandwidth() + barSize / 2)
                .attr("y", d => {
                    return (d.actual > 0 ? (yScale(d.actual) - 8) : (emptyValueY - 8))
                })
                .attr("height", d => {

                    return d.actual > 0 ? (svgHeight - margin.top - margin.bottom - yScale(d.actual) + 8) : (emptyValueHeight + 8);
                })
                .attr('text-anchor', 'middle')
                .text((a) => {
                    if (a.actual % 1 != 0) return displayType === GoalInputTypeEnum.Currency ? metricLabel + `${a.actual.toFixed(2)}` : `${a.actual.toFixed(2)}` + metricLabel
                    else return displayType === GoalInputTypeEnum.Currency ? metricLabel + `${a.actual}` : `${a.actual}` + metricLabel
                })
                .transition()
                .duration((d) => {
                    return d.actual > 0 ? duration : 0;
                })
                .attr('opacity', 1);

            /* Add field1 bars */
            model_name.selectAll(".bar.field1")
                .data(d => [d])
                .enter()
                .append("rect")
                .attr("class", "bar field1")
                .style("fill", goalBarColor)
                .attr("x", d => xScale1('actual') - barSize)
                .attr("y", yScale(0) - 2)
                .attr("height", 2)
                .attr("width", xScale1.bandwidth())
                .transition()
                .delay((d) => {
                    return d.goal > 0 ? 200 : 0;
                })
                .duration((d) => {
                    return d.goal > 0 ? duration : 0;
                })
                .attr("y", d => {
                    return d.goal > 0 ? yScale(d.goal) : emptyValueY
                })
                .attr("height", d => {
                    return d.goal > 0 ? (svgHeight - margin.top - margin.bottom - yScale(d.goal)) : emptyValueHeight;
                })
            barGroups.selectAll(".bar.field1")
                .data(d => [d])
                .enter()
                .append('text')
                .attr('opacity', 0)
                .attr('class', 'value')
                .attr('x', (a) => xScale0(a.label) + xScale1.bandwidth() - barSize / 2)
                .attr("y", d => {
                    return (d.goal > 0 ? (yScale(d.goal) - 8) : (emptyValueY - 8))
                })
                .attr("height", d => {
                    return d.goal > 0 ? (svgHeight - margin.top - margin.bottom - yScale(d.goal) + 8) : (emptyValueHeight + 8);
                })
                .attr('text-anchor', 'middle')
                .text((a) => {
                    if (a.goal % 1 != 0) return displayType === GoalInputTypeEnum.Currency ? metricLabel + `${parseFloat(a.goal).toFixed(2)}` : `${parseFloat(a.goal).toFixed(2)}` + metricLabel
                    else return displayType === GoalInputTypeEnum.Currency ? metricLabel + `${a.goal}` : `${a.goal}` + metricLabel
                })
                .transition()
                .duration((d) => {
                    return d.goal > 0 ? duration : 0;
                })
                .attr('opacity', 1)

            // Add the X Axis
            svg.append("g")
                .attr("class", "x axis")
                .attr("transform", `translate(0,${svgHeight - margin.top - margin.bottom})`)
                .call(xAxis)
                .selectAll('.tick text')
                    .call((text) => {
                        text.each(function () {
                            const _text = d3.select(this);
                            const str = _text.text().split(',');
                            const dy = parseFloat(_text.attr("dy"));
                            const y = _text.attr("y");
                            _text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em").text(str[0]);
                            _text.append("tspan").attr("x", 0).attr("y", y).attr("dy", (1 + dy) + "em").text(str[1]);
                        })
                    });

            // Add the Y Axis
            var yAxisVar = svg.append("g")
                .attr("class", "y axis")
                .call(yAxis);

            // Used for scrolling the Y-Axis
            if (document.getElementById(`${className} id`)){
               document.getElementById(`${className} id`).addEventListener('scroll',function(e){
                    let left = document.getElementById(`${className} id`).scrollLeft;
                    yAxisVar.attr("transform", `translate(${left},0)`)
                    yAxisVar.call(yAxis);
                    })
            }
        }

        // Switch date range parameters regarding global date range params
        public changeSelectedDateRange(): void {
            let filteredDateRange;

            switch (this.goalsCategory) {
                case GoalCategoryEnum.Service:
                case GoalCategoryEnum.Retail:
                case GoalCategoryEnum.GiftCard:
                    filteredDateRange = this.salesDateRangeList.find(range => range.value === this.globalSelectedDateRange);
                    break;
                case GoalCategoryEnum.AverageTicket:
                    filteredDateRange = this.averageTicketDateRangeList.find(range => range.value === this.globalSelectedDateRange);
                    break;
                case GoalCategoryEnum.NewClientRetention:
                case GoalCategoryEnum.RepeatClientRetention:
                    filteredDateRange = this.retentionDateRangeList.find(range => range.value === this.globalSelectedDateRange);
                    break;
                case GoalCategoryEnum.Rating:
                case GoalCategoryEnum.FrequencyOfVisit:
                case GoalCategoryEnum.NewClientsPerMonth:
                    filteredDateRange = this.ratingsDateRangeList.find(range => range.value === this.globalSelectedDateRange);
                    break;
                case GoalCategoryEnum.Productivity:
                    filteredDateRange = this.productivityDateRangeList.find(range => range.value === this.globalSelectedDateRange);
                    break;
                case GoalCategoryEnum.Rebook:
                    filteredDateRange = this.rebookDateRangeList.find(range => range.value === this.globalSelectedDateRange);
                    break;
                case GoalCategoryEnum.RequestRate:
                case GoalCategoryEnum.Membership:
                    filteredDateRange = this.ratesDateRangeList.find(range => range.value === this.globalSelectedDateRange);
                    break;
            }

            this.selectedDateRange = filteredDateRange || { value: GoalDateRangeEnum.YearToDate, label: 'LABEL_YTD' };
        }

        public isTrendingGraph(): boolean {
            return this.goalsCategory === GoalCategoryEnum.Productivity &&
                (this.selectedDateRange.value === GoalDateRangeEnum.Today ||
                this.selectedDateRange.value === GoalDateRangeEnum.Yesterday ||
                this.selectedDateRange.value === GoalDateRangeEnum.ThisMonth ||
                this.selectedDateRange.value === GoalDateRangeEnum.LastMonth);
        }
    }

    angular.module('meevo.components.controls')
        .component('meevoGoalsTileComponent', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/charts/goalsTile/goalsTile.template.html',
            controller: MeevoGoalsTileComponent,
            controllerAs: 'vm2',
            bindings: {
                title: '@',
                dateRange: '<',
                goal: '<',
                actual: '<',
                numberDisplayType: '<',
                currentGoalsModel: '=',
                salesData: '<?',
                onDateRangeSelection: '&',
                chartClass: '@',
                goalsCategory: '<',
                globalSelectedDateRange: '=',
                globalSelectedYear: '=?'
            },
            transclude: true,
        })
}